import Vue from 'vue';

const state = {
  lista: [],
  detalle : {},
};

const actions = {
  fetchLista:({commit},id) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post(`curso/${id}/correo`).then(
        response =>{
          commit('setLista',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchDetalle:({commit},obj) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
    Vue.http.post(`curso/${obj.curso_id}/correo/detalle`,{id:obj.id}).then(
        response =>{
          commit('setDetalle',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  crear:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
        Vue.http.post(`curso/${data.get('curso_id')}/correo/crear`,data).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  
  editar:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post(`curso/${data.get('curso_id')}/correo/editar`,data).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  eliminar:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post(`curso/${data.curso_id}/correo/eliminar`,data).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error.data, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  }
  
};

const getters = {
  getCurso: (state) => (id) =>{
    return state.lista.find(element =>{
      return element.id == id
    })
  },
  getCursoDetalle: (state) => (id) =>{
    if(!state.detalle[id]){
      Vue.set(state.detalle, id, {})
    }
    return state.detalle[id]
  }
};

const mutations = {
  setLista: (state, lista) => {
    state.lista = lista;
  },
  setDetalle: (state, detalle) => {
    let id = detalle.id;
    Vue.set(state.detalle, id, detalle)
  },
  
  incializarDetalle: (state, id) => {
    if(!state.detalle[id]){
      Vue.set(state.detalle, id, null)
    }
  }
  
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
